import axios from 'http.service';

const baseUrl = '/api/v2/appointments';

const updateAppointment = async (year, grouping, appointment, patchUpdate) => {
	const { appointmentId, type } = appointment;
	const groupingEncoded = encodeURIComponent(grouping);
	const typeEncoded = encodeURIComponent(type);
	const url = `${baseUrl}/${year}/${groupingEncoded}/${appointmentId}?type=${typeEncoded}`;
	try {
		const { status } = await axios.patch(url, patchUpdate);
		return { appointmentId, updated: status === 200 };
	} catch (error) {
		return { appointmentId, updated: false };
	}
};

export const updateAppointments = async (year, grouping, appointments, patchUpdate) => {

	// (15000 is based on average processing speed for 1000 rows)
	const delayIncrement = 15000;

	const promises = appointments.map((appointment, index) => {
		
		//	This should set any calls above 1000 to have a delay according to the row count 
		let delay = index > 1000 ? (delayIncrement + index) : 0;
		
	  	return new Promise(resolve => setTimeout(resolve, delay)).then(() =>
	  		updateAppointment(year, grouping, appointment, patchUpdate));
	})
  
	let result = await Promise.all(promises);

	const updatedIds = result.filter(outcome => outcome.updated).map(outcome => outcome.appointmentId);
	const failedIds = result.filter(outcome => !outcome.updated).map(outcome => outcome.appointmentId);
	return {
		updatedAll: updatedIds.length === appointments.length,
		updatedIds,
		failedIds,
	};
};